// src/redux/apiSlice.ts
import { createApi, fetchBaseQuery, FetchBaseQueryError, FetchArgs } from '@reduxjs/toolkit/query/react';
import oktaService from '@/services/OktaService';
import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import { backendApiUrl } from '@/lib/config';

type ApiConnectivityState = {
    offline?: { isOfflineMode?: boolean };
    netWork?: { isOnline?: boolean };
};

export const shouldDisableApiRequests = (state: ApiConnectivityState) => (
    state.offline?.isOfflineMode === true || state.netWork?.isOnline === false
);

const baseQuery = fetchBaseQuery({
    //where to put this VITE_API_URL?
    baseUrl: backendApiUrl,
    prepareHeaders: async (headers) => {
        try {
            // Get the current user from Okta
            const oktaUser = await oktaService.getUser();


            // If we have a user and an access token, add it to the headers
            if (oktaUser.access_token) {

                headers.set('authorization', `Bearer ${oktaUser.access_token}`);
                // headers.set('Access-Control-Allow-Origin', '*');
                //  headers.set('issite', 'true');
            }
        } catch (error) {
            console.error('Error getting Okta token:', error);
        }

        return headers;
    },
});

const customBaseQuery = async (
    args: string | FetchArgs,
    api: BaseQueryApi,
    extraOptions: Record<string, unknown>
) => {
    // Skip API calls in offline mode
    if (shouldDisableApiRequests(api.getState() as ApiConnectivityState)) {
        return {
            data: null,
            error: {
                status: 'CUSTOM_ERROR',
                data: 'Offline mode - API calls disabled'
            } as FetchBaseQueryError
        };
    }

    return baseQuery(args, api, extraOptions);
};

export const apiSlice = createApi({
    baseQuery: customBaseQuery,

    tagTypes: ['LpnNumbers', 'Pallet', 'PalletDetails', "User", "Project", "Media", "getProjects", "DefectKeys", "PalletConfig"],

    endpoints: () => ({}),

});
